/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Livid_Equal_Moth_OfferInputs */

const fr_livid_equal_moth_offer = /** @type {(inputs: Livid_Equal_Moth_OfferInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afin de pouvoir te connecter, tu dois créer un nouveau mot de passe.`)
};

/**

* @param {Livid_Equal_Moth_OfferInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const livid_equal_moth_offer = /** @type {((inputs?: Livid_Equal_Moth_OfferInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Livid_Equal_Moth_OfferInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_livid_equal_moth_offer(inputs)
});